export type UserRole = "superuser" | "admin" | "staff" | "talent" | "partner";

export interface UserProfile {
  id: string;
  given_name?: string;
  family_name?: string;
  email: string;
  company_id?: string;
  partner_id?: string;
  role: UserRole;
  isSuperUser: boolean;
  // If the user is anonymous it means they have not logged in yet.
  // Or they are in a intermediate state, for example due to loading.
  anonymous: boolean;
}

export function isAdmin(role: string | null): boolean {
  return role === "admin" || role === "superuser";
}

export function isStaff(role: string | null): boolean {
  return role === "staff";
}

export function isPartner(role: string | null): boolean {
  return role === "partner";
}

export function canViewSettings(): boolean {
  return true; // Settings always visible
}

export function getProfileTableFromUserRole(
  role: UserRole
): string | undefined {
  if (role === "talent") {
    return "talent_profiles";
  } else if (role === "partner") {
    return "partner_profiles";
  } else if (role === "admin" || role === "staff") {
    return "employer_profiles";
  }
}
